export default function CompanyCredits() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="19.952" height="19.951" viewBox="0 0 19.952 19.951">
            <path id="Path_323" data-name="Path 323" d="M11,2.05V5.07A7.005,7.005,0,0,0,5,12a7.094,7.094,0,0,0,5.247,6.779A6.424,6.424,0,0,0,12,19a6.963,6.963,0,0,0,4.192-1.394l2.137,2.137A10,10,0,1,1,11,2.05ZM21.95,13a9.948,9.948,0,0,1-2.207,5.328l-2.137-2.136A6.958,6.958,0,0,0,18.929,13h3.022ZM13,2.05A10,10,0,0,1,21.952,11H18.93A7,7,0,0,0,13,5.071V2.049Z" transform="translate(-2 -2.049)" fill="#0d5ac6"/>
        </svg>
    )
}